// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

import { Environment } from './environment.model';

export const environment: Environment = {
  production: false,
  branding: {
    appName: 'Hunter',
    copyright: `${new Date().getFullYear()} Spryfox GmbH`,
    logo: {
      full: 'assets/img/spryfox-logo.png',
      mark: 'assets/img/spryfox-logo-mark.png',
      onLight: 'assets/img/spryfox-logo.png',
    },
  },
  //apiBase: 'https://pfp955kmda.execute-api.eu-west-1.amazonaws.com/hunter',
  apiBase: 'https://api.hunter-dev.spryfox.de/hunter',

  userPoolData: {
    UserPoolId: 'eu-west-1_7iWP9FDU8',
    ClientId: '60j34ucsdb6vsg0f04mnq9t89k',
  },
  creadentials: {
    usr: '',
    pwd: '',
  },
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
